import React from 'react';
import { Link } from 'react-router-dom';

// Dictionary mapping Semantic Entities to Target Routes
const keywords = {
  // --- USER DEFINED KEYWORDS ---
  "Dynamic Professional Skills": "/",
  "Dynamic Professional Skills Mathura": "/",
  "DPS": "/",
  "DPS Educational Society": "/",
  "DPS Educational Society Olympiads": "/olympiads",
  "Kedti Computer Institute": "/about",
  "Mathura": "/about",
  "Mathura Olympiads": "/olympiads",
  "Mathura Competition": "/olympiads",
  "Mathura News": "/",
  "Mathura Exams": "/olympiads",
  "Mathura Olympiad": "/olympiads",
  "Mathura Olympiad exams": "/olympiads",
  "Mathura Olympiads registration": "/olympiads",
  "Dynamic Exams": "/",
  "Dynamic Professional Skills Olympiad": "/olympiads",
  "Mathura digital Olympiad": "/olympiads",
  "Largest Olympiad platform in Mathura": "/",
  "Dampier Nagar Mathura": "/contact",
  "DPS Mathura Olympiad results": "/results",
  "Mathura Hindi Olympiad": "/olympiads",
  "Mathura English Olympiad": "/olympiads",
  "Mathura Maths Olympiad": "/olympiads",
  "Mathura Science Olympiad": "/olympiads",
  "Mathura Social Studies Olympiad": "/olympiads",
  "Mathura Computer Olympiad": "/olympiads",
  "Mathura Commerce Olympiad": "/olympiads",
  "Hindi Olympiad": "/olympiads",
  "English Olympiad": "/olympiads",
  "Maths Olympiad": "/olympiads",
  "Mathematics Olympiad": "/olympiads",
  "Science Olympiad": "/olympiads",
  "Social Studies Olympiad": "/olympiads",
  "Computer Olympiad": "/olympiads",
  "Commerce Olympiad": "/olympiads",
  "Mobile based Exam": "/",
  "Mobile based test": "/",
  "Mobile based Olympiad": "/",
  "India`s first": "/",
  "India`s first mobile Olympiad": "/",
  "Mobile Olympiad": "/",
  "Online exam": "/olympiads",
  "Online Olympiad": "/olympiads",
  "best Olympiads in Mathura": "/",
  "best Olympiad": "/",
  "Dainik Bhaskar Mathura news": "/gallery",
  "Hindustan newspaper Mathura": "/gallery",
  "Mathura Jagran news": "/gallery",
  "Unique Samay Mathura": "/gallery",
  "Uttar Pradesh": "/about",
  // Hindi
  "Hindi Olympiad for Class 6": "/olympiads",
  "Hindi Olympiad for Class 7": "/olympiads",
  "Hindi Olympiad for Class 8": "/olympiads",
  "Hindi Olympiad for Class 9": "/olympiads",
  "Hindi Olympiad for Class 10": "/olympiads",
  "Hindi Olympiad for Class 11": "/olympiads",
  "Hindi Olympiad for Class 12": "/olympiads",
  // English
  "English Olympiad for Class 6": "/olympiads",
  "English Olympiad for Class 7": "/olympiads",
  "English Olympiad for Class 8": "/olympiads",
  "English Olympiad for Class 9": "/olympiads",
  "English Olympiad for Class 10": "/olympiads",
  "English Olympiad for Class 11": "/olympiads",
  "English Olympiad for Class 12": "/olympiads",
  // Maths
  "Maths Olympiad for Class 7": "/olympiads",
  "Maths Olympiad for Class 8": "/olympiads",
  "Maths Olympiad for Class 9": "/olympiads",
  "Maths Olympiad for Class 10": "/olympiads",
  // Science
  "Science Olympiad for Class 7": "/olympiads",
  "Science Olympiad for Class 8": "/olympiads",
  "Science Olympiad for Class 9": "/olympiads",
  "Science Olympiad for Class 10": "/olympiads",
  // Social Studies
  "Social Studies Olympiad for Class 7": "/olympiads",
  "Social Studies Olympiad for Class 8": "/olympiads",
  "Social Studies Olympiad for Class 9": "/olympiads",
  "Social Studies Olympiad for Class 10": "/olympiads",
  // Computer
  "Computer Olympiad for Class 7": "/olympiads",
  "Computer Olympiad for Class 8": "/olympiads",
  "Computer Olympiad for Class 9": "/olympiads",
  "Computer Olympiad for Class 10": "/olympiads",
  // Commerce
  "Commerce Olympiad for Class 11": "/olympiads",
  "Commerce Olympiad for Class 12": "/olympiads",

};

// Compile dictionary into sorted list of objects (longest first to avoid partial overlap bugs)
const dictionary = Object.keys(keywords)
  .sort((a, b) => b.length - a.length)
  .map(word => ({
    // Escape special characters in the keyword just in case
    regex: new RegExp(`\\b(${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})\\b`, 'gi'),
    target: keywords[word]
  }));

const replaceWithLinks = (text) => {
  if (typeof text !== 'string') return [text];

  let chunks = [text];
  let keyCounter = 0;
  
  dictionary.forEach(({ regex, target }) => {
    let newChunks = [];
    chunks.forEach(chunk => {
      if (typeof chunk === 'string') {
        const parts = chunk.split(regex);
        for (let i = 0; i < parts.length; i++) {
          if (parts[i]) {
            // Because of the capture group, matched terms will be at odd indices
            if (i % 2 === 1) { 
              keyCounter++;
              newChunks.push(
                <Link to={target} key={`sem-link-${keyCounter}-${parts[i].replace(/\s+/g, '-')}`} className="text-[var(--primary)] hover:underline font-medium transition-colors" title={`Internal link for SEO: ${parts[i]}`}>
                  {parts[i]}
                </Link>
              );
            } else {
              newChunks.push(parts[i]);
            }
          }
        }
      } else {
        newChunks.push(chunk);
      }
    });
    chunks = newChunks;
  });
  
  return chunks;
};

const SemanticInterlinker = ({ children }) => {
  const processNode = (node) => {
    if (node === null || node === undefined) return node;
    
    if (typeof node === 'string') {
      return replaceWithLinks(node);
    }
    if (typeof node === 'number') {
      return replaceWithLinks(node.toString());
    }

    if (React.isValidElement(node)) {
      // Prevent nesting links inside links
      if (node.type === Link || node.type === 'a' || node.type === 'button') {
        return node; 
      }
      
      // Prevent processing within script/style tags
      if (node.type === 'script' || node.type === 'style' || node.type === 'noscript') {
        return node;
      }
      
      return React.cloneElement(
        node,
        node.props,
        React.Children.map(node.props.children, child => processNode(child))
      );
    }
    return node;
  };

  return <>{React.Children.map(children, child => processNode(child))}</>;
};

export default SemanticInterlinker;
